/* eslint-disable no-unused-vars */
import XXH from "xxhashjs";
import randomstring from "randomstring";
import _ from "lodash";
let xxsalt = 0xabcd;
const hostname = window && window.location && window.location.hostname;
const prefix = "[UB]";
const debug = hostname === "localhost" ? true : false;

let backendHost;

let localPort = ":8000";
let localServer = "http://localhost" + localPort;

if (hostname === "crmform.ub.net" || hostname.includes("ub.net")) {
  backendHost = "https://quizapi.ub.net";
} else {
  backendHost = process.env.REACT_APP_BACKEND_HOST || localServer;
}

let config = {
  debug: hostname === "localhost" ? true : false,
  api: {
    customer_form: backendHost + "/crm/customer",
  },
  backend_host: backendHost,
  app_hostname: hostname,
  root_path: "/#/",
};

export default config;
